<!-- Usage: 
    <Expander let:expand let:expanded> 
        <div class:toExpand={!expanded} class:isExpanded={expanded}>
        <button on:click={expand}>Expand</button>
    </Expander> 
-->
<script>
	let expanded = false
	const expand = () => {
		expanded = !expanded
	}
</script>

<slot {expand} {expanded} />

<style>
	:global(.toExpand) {
		position: relative;
		display: none;
		height: 0;
		padding-top: 0;
		padding-bottom: 0;
		animation: fade-out 1s;
		animation-fill-mode: forwards;
	}
	:global(.isExpanded) {
		overflow: hidden;
		animation: fade-in 1s;
		animation-fill-mode: forwards;
	}
	@keyframes fade-in {
		0% {
			opacity: 0;
		}
		100% {
			opacity: 1;
		}
	}

	@keyframes fade-out {
		0% {
			opacity: 1;
			display: block;
		}
		99% {
			opacity: 0;
			display: block;
		}
		100% {
			opacity: 0;
			display: none;
		}
	}
</style>
